import { MetroClientsState, ReadMetroClientsActionTypes, READ_METRO_CLIENTS_DATA_REQUEST, READ_METRO_CLIENTS_DATA_SUCCESS, READ_METRO_CLIENTS_DATA_FAILURE } from "store/reducers/types/dashboard/metroClients";

const defaultState: MetroClientsState = {
  isLoading: false,
  errorMessage: ""
};

export default function metroClients(state = defaultState, action: ReadMetroClientsActionTypes): MetroClientsState {
  switch (action.type) {
    case READ_METRO_CLIENTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_METRO_CLIENTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_METRO_CLIENTS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
